module.exports = __webpack_public_path__ + "img/hotpot-logo.8f0f0976.png";